// ─────────────────────────────────────────────────────────────────────────────
// SuccessStep.js — the post-send confirmation screen (no stepper). Summarises
// what happened: email delivery, role assignment, and expiry.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../InviteModal.module.css";
import { CheckIcon, MailIcon, ShieldIcon, ClockIcon } from "../icons";

export default function SuccessStep({ form }) {
  const rows = [
    { icon: <MailIcon />,   color: "var(--accent)", label: "Email sent",         value: form.email },
    { icon: <ShieldIcon />, color: "var(--cyan)",   label: `${form.role} role assigned`, value: `${form.team} team` },
    { icon: <ClockIcon />,  color: "var(--yellow)", label: "Invite expires",     value: "in 7 days" },
  ];

  return (
    <div className={styles.success}>
      <div className={styles.successIcon}><CheckIcon size={34} /></div>
      <div className={styles.successTitle}>Invitation Sent!</div>
      <div className={styles.successText}>
        An invitation has been sent to {form.email}. They'll receive onboarding
        instructions shortly.
      </div>

      <div className={styles.statusList}>
        {rows.map((r) => (
          <div key={r.label} className={styles.statusRow}>
            <span className={styles.statusIcon} style={{ color: r.color }}>{r.icon}</span>
            <span className={styles.statusLabel}>{r.label}</span>
            <span className={styles.statusVal}>{r.value}</span>
            <span className={styles.statusCheck}><CheckIcon size={12} /></span>
          </div>
        ))}
      </div>
    </div>
  );
}
